import React, { useState, useEffect } from "react";
import { ParticipantTile } from "@livekit/components-react";
import PersonIcon from "@mui/icons-material/Person";
import { useResponsive } from "components/ResponsiveDesign/ResponsiveDesign";

const ScreenShareView = ({ screenShareTrack, participants, cameraTracks }) => {
    const { isMobile, isTablet } = useResponsive();

    return (
        <div
            style={{
                display: "flex",
                height: "calc(100vh - 80px)", // Account for fixed control bar
                flexDirection: isMobile ? "column" : "row",
            }}
        >
            {/* Main screen share area */}
            <div
                style={{
                    backgroundColor: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "100%" : isTablet ? "80%" : "85%",
                    height: isMobile ? "70%" : "100%",
                }}
            >
                <ParticipantTile
                    trackRef={screenShareTrack}
                    style={{
                        width: "95%",
                        height: "95%",
                        border: "1px solid #333",
                        padding: isMobile ? "8px" : "17px",
                        borderRadius: "8px",
                    }}
                />
            </div>

            {/* Participant sidebar */}
            <div
                style={{
                    overflowY: "auto",
                    overflowX: isMobile ? "auto" : "hidden",
                    backgroundColor: "#1e1e1e",
                    width: isMobile ? "100%" : isTablet ? "20%" : "15%",
                    height: isMobile ? "30%" : "100%",
                    display: "flex",
                    flexDirection: isMobile ? "row" : "column",
                    alignItems: "center",
                    padding: "8px",
                    gap: "8px",
                    borderTop: isMobile ? "1px solid #333" : "none",
                    borderLeft: !isMobile ? "1px solid #333" : "none",
                }}
            >
                {participants.map((participant) => {
                    const trackRef = cameraTracks.find(
                        (t) => t.participant.sid === participant.sid
                    );

                    return (
                        <ParticipantCard
                            key={participant.sid}
                            participant={participant}
                            trackRef={trackRef}
                        />
                    );
                })}
            </div>
        </div>
    );
};

// Individual participant card component
const ParticipantCard = ({ participant, trackRef }) => {
    const { isMobile, isTablet } = useResponsive();
    const displayName = participant?.identity?.length <= (isMobile ? 4 : 6)
        ? participant?.identity
        : `${participant?.identity.slice(0, isMobile ? 4 : 7)}...`;

    const cardSize = isMobile ? "70px" : isTablet ? "80px" : "90px";
    const iconSize = isMobile ? "25px" : isTablet ? "30px" : "35px";

    return (
        <div
            style={{
                width: isMobile ? cardSize : "80%",
                minWidth: cardSize,
                border: "1px solid #555",
                height: cardSize,
                borderRadius: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: isMobile ? "9px" : "11px",
                color: "white",
                textAlign: "center",
                flexShrink: 0,
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                transition: "all 0.2s ease",
                cursor: "pointer",
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                e.target.style.transform = "scale(1)";
            }}
        >
            {trackRef ? (
                <div style={{ fontSize: isMobile ? "8px" : "10px" }}>
                    <PersonIcon style={{ fontSize: iconSize, marginBottom: "2px" }} />
                    <div style={{ fontWeight: "500" }}>{displayName}</div>
                </div>
            ) : (
                <div>
                    <PersonIcon style={{ fontSize: iconSize, marginBottom: "2px", opacity: 0.7 }} />
                    <div style={{ fontWeight: "500" }}>{displayName}</div>
                    <div style={{ fontSize: isMobile ? "7px" : "8px", opacity: 0.6 }}>
                        (audio)
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScreenShareView;